import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { useCartWishlist } from "../contexts/CartWishlistContext";
import "./Cart.css";

const formatINR = (amount) =>
  new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 }).format(amount);

export default function Cart() {
  const { cart, incQty, decQty, removeFromCart, clearCart } = useCartWishlist();

  const removeItem = (id) => removeFromCart(id);

  const totals = useMemo(() => {
    const itemsCount = cart.reduce((sum, it) => sum + (it.qty || 1), 0);
    const amount = cart.reduce(
      (sum, it) => sum + (it.price || 0) * (it.qty || 1),
      0
    );
    return { itemsCount, amount };
  }, [cart]);

  return (
    <div className="cartPage">
      <div className="cartWrap">
        <div className="cartHead">
          <div>
            <h2 className="cartTitle">Your Cart</h2>
            <p className="cartSub">
              {totals.itemsCount} item(s)
              {cart.length > 0 ? ` • ₹ ${formatINR(totals.amount)}` : ""}
            </p>
          </div>

          {cart.length > 0 && (
            <button className="cartClear" type="button" onClick={clearCart}>
              Clear cart
            </button>
          )}
        </div>

        {cart.length === 0 ? (
          <div className="cartEmpty">
            <p className="cartEmptyTitle">Your cart is empty.</p>
            <Link className="cartShopBtn" to="/jewellery">
              Continue Shopping
            </Link>
          </div>
        ) : (
          <>
            {/* ✅ Small card grid */}
            <div className="cartGrid">
              {cart.map((it) => (
                <div className="cartCard" key={it.id}>
                  <Link to={it.link || "/jewellery"} className="cartMedia">
                    <img className="cartImg" src={it.img} alt={it.name} />
                  </Link>

                  <div className="cartInfo">
                    <Link to={it.link || "/jewellery"} className="cartName">
                      {it.name}
                    </Link>

                    <div className="cartItemDetails">
                      Size: {it.size || "Free Size"}
                    </div>

                    <div className="cartPriceRow">
                      <div className="cartPrice">₹ {formatINR(it.price)}</div>
                      <div className="cartLineTotal">
                        ₹ {formatINR((it.price || 0) * (it.qty || 1))}
                      </div>
                    </div>

                    <div className="cartActions">
                      <div
                        className="qty"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <button
                          type="button"
                          onClick={() => decQty(it.id)}
                          aria-label="Decrease"
                        >
                          −
                        </button>
                        <span>{it.qty || 1}</span>
                        <button
                          type="button"
                          onClick={() => {
                            if ((it.qty || 1) < (it.stockQuantity || Infinity)) {
                              incQty(it.id);
                            } else {
                              alert("Cannot add more than available stock.");
                            }
                          }}
                          disabled={(it.qty || 1) >= (it.stockQuantity || Infinity)}
                          style={{ opacity: (it.qty || 1) >= (it.stockQuantity || Infinity) ? 0.5 : 1, cursor: (it.qty || 1) >= (it.stockQuantity || Infinity) ? 'not-allowed' : 'pointer' }}
                          aria-label="Increase"
                        >
                          +
                        </button>
                      </div>

                      <button
                        className="removeBtn"
                        type="button"
                        onClick={() => removeItem(it.id)}
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* ✅ Summary */}
            <div className="cartSummary">
              <div className="sumRow">
                <span>Items</span>
                <span>{totals.itemsCount}</span>
              </div>
              <div className="sumRow total">
                <span>Total</span>
                <span>₹ {formatINR(totals.amount)}</span>
              </div>

              <Link to="/checkout" className="checkoutBtn">
                Checkout
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}